<script setup>
import { defineProps, inject } from 'vue'

const storeFourBaseUrl = inject('storeFourBaseUrl')
const props = defineProps({
  items: {
    type: Array,
    required: true
  }
})
const getIconSrc = (image) => {
  return `${storeFourBaseUrl}/filepond/menu/${image}`
}
</script>

<template>
  <v-list-item class="my-4" v-for="(item, i) in props.items" :key="i">
    <div class="d-flex flex-column align-items-center">
      <img :src="getIconSrc(item.icon_img)" class="w-100">
      <div class="measure-name my-2 w-100 d-flex flex-column justify-content-around">
        <h6>{{ item.title }}</h6>
        <span style="font-size: 0.9rem">{{ item.description }}</span>
      </div>
    </div>
  </v-list-item>
</template>


<style scoped>

</style>
